import * as types from "./mutation-type";
import { getOnboardingDataQuery,getCompanies } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async createOnboardingThirdStepData({ commit }, data) {
    try {
      commit(types.CREATE_ONBOARDING_THIRD_STEP_DATA_BEGIN);
      await api.company.createOnboardingThirdStepData(data);

      commit(types.CREATE_ONBOARDING_THIRD_STEP_DATA_SUCCESS);
    } catch (e) {
      commit(types.CREATE_ONBOARDING_THIRD_STEP_DATA_ERROR, e);
    }
  },
  
  async getOnboardingThirdStepData({ commit }, variables = {}) {
    try {
      commit(types.GET_ONBOARDING_THIRD_STEP_DATA_BEGIN)
      
      const { data:{ data:{ company } } } = await gqlClient.query({ query : getOnboardingDataQuery,variables : variables },{ timeout : 60000 })
     
      commit(types.GET_ONBOARDING_THIRD_STEP_DATA_SUCCESS, company)
    } catch (e) {
      commit(types.GET_ONBOARDING_THIRD_STEP_DATA_ERROR, e)
    }
  },
  async getCompanies({ commit }, variables = {}) {
    try {
      commit(types.GET_COMPANIES_BEGIN);
      const {
        data: {
          data   
        }
      } = await gqlClient.query({
        query     : getCompanies,
        variables : variables
      });
      commit(types.GET_COMPANIES_SUCCESS, data.system.companies);
    } catch (e) {
      commit(types.GET_COMPANIES_ERROR, e);
    }
  },
  async updateCompany({ commit }, data) {
    try {
      commit(types.UPDATE_COMPANY_BEGIN);
      await api.company.updateCompany(data.id, data);
      commit(types.UPDATE_COMPANY_SUCCESS);
    } catch (e) {
      commit(types.UPDATE_COMPANY_ERROR, e);
    }
  },
  async deleteCompany({ commit }, id) {
    try {
      commit(types.DELETE_COMPANY_BEGIN);
      await api.company.deleteCompany(id);

      commit(types.DELETE_COMPANY_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_COMPANY_ERROR, e);
    }
  },
};

export default actions;
